import createToast from 'components/Toast/Toast';


import copy from 'copy-to-clipboard';

function useCopy() {

  const copyItem = (text, message = 'کپی شد') => {
    copy(text);
    createToast('موفق',message, 'success');

  };
  return { copyItem };
}

export { useCopy };
